var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 6.66667V12.6667H3.32V3.33333H9.32V2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V6.66667H12.6667ZM10.7067 5.29333L11.3333 6.66667L11.96 5.29333L13.3333 4.66667L11.96 4.04L11.3333 2.66667L10.7067 4.04L9.33333 4.66667L10.7067 5.29333ZM8 5.33333L7.16667 7.16667L5.33333 8L7.16667 8.83333L8 10.6667L8.83333 8.83333L10.6667 8L8.83333 7.16667L8 5.33333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventHighlight);
export default __webpack_public_path__ + "static/media/event-highlight.45f621e11a5aa9b426fd33d4e8cd7b94.svg";
export { ForwardRef as ReactComponent };